import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import { createElement } from '@jd/jmtd-tools/es/element';
import { createContext } from '../tools/context';
import Icon from '../Icon';
import PortalZIndex from '../PortalZIndex';
var DrawerContext = createContext(null);
var defaultPushState = {
  distance: 50
};

var Drawer = /*#__PURE__*/function (_React$Component) {
  _inherits(Drawer, _React$Component);

  var _super = _createSuper(Drawer);

  function Drawer(props) {
    var _this;

    _classCallCheck(this, Drawer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "push", function () {
      _this.setState({
        internalPush: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pull", function () {
      _this.setState({
        internalPush: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function (portalStyle, enable) {
      var _this2, _this2$portalElement;

      var _assertThisInitialize = _assertThisInitialized(_this),
          _assertThisInitialize2 = _assertThisInitialize.props,
          id = _assertThisInitialize2.id,
          className = _assertThisInitialize2.className,
          style = _assertThisInitialize2.style,
          _assertThisInitialize3 = _assertThisInitialize2.push,
          push = _assertThisInitialize3 === void 0 ? defaultPushState : _assertThisInitialize3,
          zIndex = _assertThisInitialize2.zIndex,
          closable = _assertThisInitialize2.closable,
          maskClosable = _assertThisInitialize2.maskClosable,
          noMask = _assertThisInitialize2.noMask,
          appendCurrentDom = _assertThisInitialize2.appendCurrentDom,
          placement = _assertThisInitialize2.placement,
          open = _assertThisInitialize2.open,
          width = _assertThisInitialize2.width,
          height = _assertThisInitialize2.height,
          onClose = _assertThisInitialize2.onClose,
          children = _assertThisInitialize2.children,
          internalPush = _assertThisInitialize.state.internalPush;

      var getWrapStyle = function getWrapStyle() {
        var transform, distance;

        if (typeof push === 'boolean') {
          distance = push ? defaultPushState.distance : 0;
        } else {
          distance = push.distance;
        }

        if (placement === 'right' || placement === 'left') {
          transform = "translate3d(".concat(placement === 'left' ? distance : -distance, "px, 0, 0)");
        }

        if (placement === 'top' || placement === 'bottom') {
          transform = "translate3d(0, ".concat(placement === 'top' ? distance : -distance, "px, 0)");
        }

        return _objectSpread({
          zIndex: zIndex,
          transform: internalPush ? transform : undefined,
          position: appendCurrentDom ? 'absolute' : 'fixed'
        }, style);
      };

      var drawer = /*#__PURE__*/React.createElement("div", {
        id: id,
        className: classNames('jmtd-drawer', className, {
          'jmtd-drawer-open': open
        }),
        style: getWrapStyle()
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-drawer-mask",
        style: {
          display: noMask ? 'none' : 'hide'
        },
        onClick: function onClick() {
          if (maskClosable) {
            onClose();
          }
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "jmtd-drawer-wrap jmtd-drawer-placement-".concat(placement),
        style: placement === 'right' || placement === 'left' ? {
          width: width
        } : {
          height: height
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-drawer-content"
      }, closable && /*#__PURE__*/React.createElement("span", {
        className: "jmtd-drawer-delete-icon",
        onClick: onClose
      }, /*#__PURE__*/React.createElement(Icon, {
        size: "large",
        className: "jmti-close"
      })), children)));

      if (appendCurrentDom) {
        return drawer;
      }

      (_this2$portalElement = (_this2 = _this).portalElement) !== null && _this2$portalElement !== void 0 ? _this2$portalElement : _this2.portalElement = createElement('div.jmtd-drawer-portal', {
        classList: enable ? ['jmtd-portal-adjust'] : [],
        style: portalStyle
      }, document.body);
      return /*#__PURE__*/ReactDOM.createPortal(drawer, _this.portalElement);
    });

    _this.state = {
      internalPush: false
    };
    return _this;
  }

  _createClass(Drawer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var open = this.props.open;

      if (prevProps.open !== open && this.parentDrawer) {
        if (open) {
          this.parentDrawer.push();
        } else {
          this.parentDrawer.pull();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.parentDrawer) {
        this.parentDrawer.pull();
        this.parentDrawer = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React.createElement(PortalZIndex, null, function (_ref) {
        var portalStyle = _ref.style,
            enable = _ref.enable;
        return /*#__PURE__*/React.createElement(DrawerContext.Consumer, null, function (drawer) {
          _this3.parentDrawer = drawer;
          return /*#__PURE__*/React.createElement(DrawerContext.Provider, {
            value: _this3
          }, _this3.renderContent(portalStyle, enable));
        });
      });
    }
  }]);

  return Drawer;
}(React.Component);

export { Drawer as default };
Drawer.propTypes = {
  id: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  push: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  className: PropTypes.string,
  zIndex: PropTypes.number,
  maskClosable: PropTypes.bool,
  noMask: PropTypes.bool,
  appendCurrentDom: PropTypes.bool,
  open: PropTypes.bool,
  closable: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node
};
Drawer.defaultProps = {
  id: null,
  width: 300,
  height: 300,
  style: {},
  push: {
    distance: 50
  },
  placement: 'right',
  className: '',
  zIndex: 100,
  maskClosable: false,
  noMask: false,
  appendCurrentDom: false,
  open: false,
  closable: false,
  onClose: function onClose() {},
  children: ''
};